module.exports = __webpack_public_path__ + "static/media/loading2.a00e4b28.mp4";